module.exports = "<invoice-item-page></invoice-item-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appPlans/invoiceitem.html
// module id = 1731
// module chunks = 0